import { useContext, useState } from 'react';
import { toast } from 'react-toastify';
import axios from '../../../axios';
import { AuthContext } from '../../../shared';
import { ADMIN_API, BEEHERO_IO_URL, FORBIDDEN, OK, SERVICE_STATE } from '../../../shared/consts';
import { loggedInSuccessfullyText, passwordExpiredText, somethingWentWrongText } from '../textConsts';

const passwordExpiredMessage = 'Password expired';

export const useLogin = (setLoading, queryParams, appRedirection) => {
    const { refreshAuth, serviceState } = useContext(AuthContext);
    const [loginError, setLoginError] = useState(null);
    const [passwordResetUrl, setPasswordResetUrl] = useState(null);

    const requestPasswordReset = async (email) => {
        try {
            const res = await axios.post(`${ADMIN_API}/reset_password_request`, {
                email,
                delivery_method: 'url'
            });
            if (res.status === OK) {
                setLoading(false);
                setPasswordResetUrl(res.data.url);
                setLoginError(passwordExpiredText);
            }
        } catch (err) {
            setLoading(false);
            if (serviceState === SERVICE_STATE.OK) {
                setLoginError(err.response.data.message);
            }
        }
    };

    const handleLoginError = (err, email) => {
        if (serviceState === SERVICE_STATE.OK) {
            setLoading(false);
            const errorMessage = err.response?.data?.message;

            if (errorMessage === passwordExpiredMessage) {
                setLoading(true);
                requestPasswordReset(email);
                return;
            }

            if (err.response?.data?.code === FORBIDDEN) {
                window.open(BEEHERO_IO_URL, '_blank');
            }

            setLoginError(errorMessage || somethingWentWrongText);
            setPasswordResetUrl(null);
        }
    };

    const handleLogin = async (data) => {
        setLoading(true);
        setLoginError(null);
        setPasswordResetUrl(null);
        try {
            const res = await axios.post(`${ADMIN_API}/login`, { ...data, to: appRedirection });
            if (res.status === OK) {
                const redirectUrl = res.data.redirect_url;
                if (redirectUrl) {
                    setLoading(false);
                    toast.success(loggedInSuccessfullyText);
                    window.location.href = `${redirectUrl}${queryParams}`;
                } else {
                    setLoading(false);
                    refreshAuth();
                }
            }
        } catch (err) {
            handleLoginError(err, data.email);
        }
    };

    const navigateToPasswordReset = () => {
        if (passwordResetUrl) {
            window.location.href = passwordResetUrl;
        }
    };

    return {
        handleLogin,
        loginError,
        passwordResetUrl,
        navigateToPasswordReset
    };
};
